import React, { useState } from 'react'
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form'
import * as yup from 'yup';
import _ from 'lodash'
import styled from 'styled-components';
import api from '@api/Apis';
import HomeSectionFive from '@PagesComponent/Home/HomeSections/HomeSectionFive';
import HomeComponent from '@PagesComponent/Home/HomePageStyle';

const SampleCodeReportStyle = styled.div`
    width: 100%;
    height: 100%; 
    padding-top:172px;
 form.signupform.main-sign-frm {

    max-width: 1024px !important;
    text-align: center;

    @media (max-width:568px){
        padding: 15px;
        text-align: left;
    }

    .title_form {
        margin-bottom: 30px;
        h2{
            color: #fff;
            text-align: center;
            margin-bottom: 0px;
            font-size: 26px;
        }
        @media (max-width: 767px) {
            h2{
                font-size: 16px;
            }
        }
        @media (max-width: 480px) {
            h2{
                font-size: 12px;
            }
        }
    }
    .main_title {
        margin-bottom: 60px;
        h2 {
            color: #fff;
        }
        @media (max-width: 767px) {
            margin-bottom: 20px;
            h2{
                font-size: 20px;
            }
        }
    }
    .all_fields {
        width: 100%;
        max-width: 650px;
        margin: 0 auto;
    }
    
button.MuiButtonBase-root {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 9;
    background: #fff;
    border-radius: 0;
        }
    svg.MuiSvgIcon-root {
    font-size: 2px;
    color: var(--green);
} 
.form-control,select#myId {
    line-height: normal;
    border-radius: 30px;
    width: 100%;
    height: 40px;
    border: 1px solid #b2b2b2;
    font-size: 16px;
    max-width: 100%;
    text-align: left;
    color: #999999;
}

button.btn-primary {
    font-size: 20px;
    color: #000000;
    font-weight: bold;
    font-family: "Exo";
    text-align: center;
    background: #fff;
    border-radius: 30px;
    width: 100%;
    max-width: 220px;
    margin: 20px auto 0;
    text-transform: uppercase;
    display: flex;
    font-weight: 600;
    justify-content: center;
}
.form-check {
      margin: 20px 0 15px;
      .form-group {
        margin-bottom: 0;
        input {
          padding: 0;
          height: initial;
          width: initial;
          margin-bottom: 0;
          display: none;
          cursor: pointer;
        }
        label {
          position: relative;
          cursor: pointer;
          @media (max-width: 767px) {
            align-items: flex-start;
          }
          &:before {
            content: "";
            -webkit-appearance: none;
            background-color: transparent;
            border: 2px solid #fff;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
              inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
            padding: 0px;
            display: inline-block;
            position: relative;
            vertical-align: middle;
            cursor: pointer;
            margin-right: 5px;
            border-radius: 30px;
            width: 18px;
            height: 18px;
            @media (max-width: 767px) {
              flex: 18px;
              min-width: 18px;
              top: 2px;
              max-width: fit-content;
            }
          }
        }
        input:checked + label:before {
          background: #fff;
        }
        input:checked + label:after {
          content: "";
          display: block;
          position: absolute;
          top: 4px;
          left: 6px;
          width: 5px;
          height: 11px;
          border: solid var(--green);
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
          @media (max-width: 767px) {
            top: 7px;
          }
        }
        input:checked + label {
          color: #fff;
        }
      }
    }
}   
`;
const SampleCodeReport = (props) => {
    const { openForm, setOpenForm } = props;
    const [newsLetter, setNewsLetter] = useState()
    const [successMsg, setSuccessMsg] = useState('');
    const [errorMsg, setErrorMsg] = useState();
    const schema = yup.object().shape({
        first_name: yup.string().trim()
            .required('First name is required'),
        // .min(3, 'Enter minimum 3 character'),
        last_name: yup.string().trim()
            .required('Last name is required'),
        // .min(3, 'Enter minimum 3 character'),
        email: yup.string().trim()
            .required('Email is required')
            .email('Please enter valid email'),

    })

    const { register, handleSubmit, reset, errors } = useForm({
        mode: 'onChange', resolver: yupResolver(schema), defaultValues: {
            newslettercheck: true
        }
    });

    function _InputField(fieldName, placeHolder, label = null) {
        return (
            <div className="mb-3 field-class">
                {label && <label htmlFor={fieldName}>{label}</label>}
                <input type="text" className="form-control" name={fieldName} placeholder={placeHolder} ref={register} />
                {errors[fieldName] && <span className="error">{errors[fieldName]?.message}</span>}
            </div>
        )
    }

    async function onSubmit(data) {
        await api.newsletter(data).then((res) => {
            if (res?.data?.code === 1) {
                setNewsLetter(res?.data)
                setSuccessMsg(res?.data?.message)
                setTimeout(() => {
                    setSuccessMsg('')
                }, 3000);
                reset({
                    wellness: "Individual",
                    first_name: "",
                    last_name: "",
                    email: ""
                })
            }
            if (res?.data?.code === 0) {
                setErrorMsg(res?.data?.message);
                setTimeout(() => {
                    setErrorMsg('')
                }, 3000);
            }
        })
    }
    return (
        <>
            <SampleCodeReportStyle>
                <div className='left-img'><img src="/images/molecularleft.png" /></div>
                <div style={{ background: '#5FB5BE' }} >
                    <form className="signupform main-sign-frm" style={{ background: '#5FB5BE' }} onSubmit={handleSubmit(onSubmit)}>
                        <div className='signup'>
                            <div className='main_title'>
                                <h2>SIMPLY. GENIUS.</h2>
                                <h2>DNA-Personalized Nutrition.</h2>
                            </div>
                            <div className='title_form'>
                                <h2>GET A SAMPLE PREMIUM</h2>
                                <h2>CODE DNA REPORT</h2>
                            </div>
                            <div className='all_fields'>
                                {_InputField('first_name', "First Name*")}
                                {_InputField('last_name', "Last Name")}
                                {_InputField('email', "E-mail*")}

                                <select className="form-control" id="Choose" name="wellness" ref={register({
                                    required: "This field is required",
                                })}>
                                    <option value="Individual">Individual</option>
                                    <option value="Wellness professional">Wellness Professional</option>
                                    <option value="retailer">Retailer</option>
                                    <option value="employer">Employer</option>
                                    <option value="other">Other</option>
                                </select>
                                <div className="mb-0 mt-3 field-class">
                                    <button type="submit" className=" btn-primary">Submit</button>
                                </div>
                                {successMsg && <span className='error' style={{ color: 'green', textAlign: "center", padding: '30px', fontSize: '18px' }}>{successMsg}</span>}
                                {errorMsg && <span className='error' style={{ color: 'red', textAlign: "center", padding: '30px', fontSize: '18px' }}>{errorMsg}</span>}
                            </div>
                            <div className="mb-3 form-check field-class">
                                <div className="form-group">
                                    <input type="checkbox" ref={register({ required: false })} className="form-check-input" id="Terms-Condition" name="newslettercheck" />
                                    <label className="form-check-label" htmlFor="Terms-Condition">
                                        Keep up-to-date with what's happening with our newsletter!
                                    </label>
                                </div>
                            </div>
                            <div className="mb-3 form-check field-class">
                                <div className="form-group">
                                    <input type="checkbox" ref={register({ required: false })} defaultChecked={true} className="form-check-input" id="promotions" name="promotionsignup" />
                                    <label className="form-check-label" htmlFor="promotions">
                                        Sign up for exclusive announcements, promotions, and the latest updates straight to your inbox.
                                    </label>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <HomeComponent>
                    <HomeSectionFive hideContent={true} />
                </HomeComponent>
            </SampleCodeReportStyle >
            {/* } */}
        </>
    )
}

export default SampleCodeReport;